export default __webpack_public_path__ + "static/media/Group_12506.aae9146c.svg";